import { Component,Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Menu } from '../../../../../asistente-en-linea/models/Menu';
import { MenuService } from '../../menu.service';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-import-menu-dialog',
  templateUrl: './import-menu-dialog.component.html',
  styleUrls: ['./import-menu-dialog.component.scss']
})
export class ImportMenuDialogComponent implements OnInit {
  destinatarios: string[];
  validaciones: string[];
  destinatariosNoAsociados: string[];
  eliminado: boolean;                    
  formData: any = null;
  respuestaImportacion:any=null;
  selectedFile: any = null;
  habilitarBotonImportar: boolean;
  mostrarMensajeEjecutando: boolean;
  ejecutando : boolean;
  finalizado : boolean;
  mensaje: string;
  error: boolean;
  constructor(private menuService: MenuService,private authService: AuthService,public dialogRef: MatDialogRef<ImportMenuDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: Menu) {
    this.eliminado =  false;   
    this.habilitarBotonImportar = false;  
    this.mostrarMensajeEjecutando = false;
    this.ejecutando = false;    
    this.finalizado = false;
    this.error = false;                                                 
  }

  ngOnInit() {
  }
  cancelarAceptar(): void {
    this.dialogRef.close();                         
  }

  onFileSelected(event: any): void {
    this.formData = null;
    this.error = false;
    this.habilitarBotonImportar = false;
    this.selectedFile =  event.target.files ? event.target.files[0]:null;
 
    var extension = this.selectedFile.name.split('.').pop();
    if(extension && extension.toUpperCase() ==='JSON'){
      this.formData = new FormData();
      this.formData.append('file', new Blob([JSON.stringify(this.selectedFile )],{type:'multipart/form-data'}));
      this.formData.append('fileName', this.selectedFile.name);
      //this.formData = e.target.result;
      this.habilitarBotonImportar = true;

      if (typeof (FileReader) !== 'undefined') {
        const reader = new FileReader();

        reader.onload = (e: any) => {

          const result = this.patchEncoding(e.target.result) ;
          this.formData = new FormData();
          this.formData.append('file', new Blob([result],{type:'multipart/form-data;'}));
          this.formData.append('fileName', this.selectedFile.name);
          this.habilitarBotonImportar = true;
        };
        reader.readAsText(this.selectedFile,'ISO-8859-1');
      }
    } else {
      this.error = true;
      this.mensaje = "Debe seleccionar un archivo en formato JSON";
    }
  }

  patchEncoding(valor: string): string {
    if (valor) {
      let resultado = valor.replace(/ñ/g, '&ntilde;').replace(/Ñ/g, '&Ntilde;');
      resultado = resultado.replace(/á/g, '&aacute;').replace(/Á/g, '&Aacute;');
      resultado = resultado.replace(/é/g, '&eacute;').replace(/É/g, '&Eacute;');
      resultado = resultado.replace(/í/g, '&iacute;').replace(/Í/g, '&Iacute;');
      resultado = resultado.replace(/ó/g, '&oacute;').replace(/Ó/g, '&Oacute;');
      resultado = resultado.replace(/ú/g, '&uacute;').replace(/Ú/g, '&Uacute;');
      resultado = resultado.replace(/ü/g, '&uuml;').replace(/Ü/g,'&Uuml;');
      resultado = resultado.replace(/¿/g, '&iquest;');
      resultado = resultado.replace(/!/g, '&#33;');
      resultado = resultado.replace(/¡/g, '&#161;');
      return resultado;
      
    } else { 
      return valor 
    }
  }

  async importarMenu()  {
    this.respuestaImportacion = null;
    this.error = false;   
    this.ejecutando = true;
    this.finalizado = false;
    this.habilitarBotonImportar = false;   
    this.mostrarMensajeEjecutando = true;
    this.destinatarios = [];
    this.validaciones = [];
    this.destinatariosNoAsociados=[];
    this.menuService.importarMenu(this.formData,this.data.id,this.authService.getUser().username).subscribe((data: any) => {
      if (data && (data.statusCode == 200 ||data.statusCode ==0)) {
        this.respuestaImportacion=data;
        this.selectedFile = null;
        this.mostrarMensajeEjecutando = false;
        this.finalizado = true;
        if (data.destinatariosFaltantes && data.destinatariosFaltantes.length > 0) {
          for (let m of data.destinatariosFaltantes) {
            this.destinatarios.push(m.codigo + " - " + m.titulo);
          }
        } 
        if (data.destinatariosNoAsociados && data.destinatariosNoAsociados.length > 0) {
          for (let m of data.destinatariosNoAsociados) {
            this.destinatariosNoAsociados.push(m.codigo + " - " + m.titulo);
          }
        }
        if (data.validacionesFaltantes && data.validacionesFaltantes.length > 0) {
          for (let m of data.validacionesFaltantes) {
            this.validaciones.push(m.codigo + " - " + m.nombre);
          }
        }
        
      } else {
        this.mensaje = data.statusMessage;
        //alert(data.statusMessage);
        this.ejecutando = false;
        this.error = true;   
      }
    },
    error=>{
      //alert(error);
      this.mensaje = error;
      this.ejecutando = false;
      this.error = true;   
    })
  }
  
  exportarDestinatariosValidacionesFaltantes() {
    this.menuService.exportarDestinatariosAsistentes(this.data.id, this.respuestaImportacion) .subscribe(blob => { 
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
  
        a.href = objectUrl;
        a.download = this.data.descripcion + ".xlsx";
        a.click();
  
        URL.revokeObjectURL(objectUrl);
  
      }, error => {
        console.error(error);
        alert("La operación falló");
      });
  } 
}